import { openDB, deleteDB } from 'idb';

import { STORE_NAME as gtmEfficiency } from '@/components/GTMEfficiency/constants';

const dbName = 'ARM-RRM';

const openingDB = async () => {
    const DB = await openDB(dbName, 1, {
        upgrade(db) {
            db.createObjectStore(gtmEfficiency);
        },
    });

    return DB;
};

export const getStoreData = async ({ name, key }) => {
    try {
        const value = await (await openingDB()).get(name, key);
        return value;
    } catch (error) {
        return null;
    }
};

export const setStoreData = async ({ name, value, key }) => {
    try {
        await (await openingDB()).put(name, value, key);
        return true;
    } catch (error) {
        return error;
    }
};

export const deleteStoreData = async ({ name, key }) => {
    try {
        await (await openingDB()).delete(name, key);
        return true;
    } catch (error) {
        return error;
    }
};

export const clearStore = async ({ name }) => {
    try {
        await (await openingDB()).clear(name);
        return true;
    } catch (error) {
        return error;
    }
};

export const closeIndexedDB = async () => {
    return (await openingDB()).close();
};

export const deleteIndexedDB = async () => {
    await deleteDB(dbName);
};
